import { render, staticRenderFns } from "./DeletionRequest.vue?vue&type=template&id=cdd37362"
import script from "./DeletionRequest.vue?vue&type=script&lang=ts"
export * from "./DeletionRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports